import React from 'react'

import './container.css'

export const Container = ({ children, isfluid=false, isTight=false }) => {
    return (
        <div className={isfluid ? 'container-fluid' : isTight ? 'container-tight': 'container-custom'}>
            {children}
        </div>
    )
}